/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationPaymentPathParameters } from 'api/actions/get-reservation-payment/get-reservation-payment-path-parameters';
import { GetReservationPaymentResponse } from 'api/actions/get-reservation-payment/get-reservation-payment-response';

type GetReservationPaymentQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationPayment action.
 */
export const getReservationPaymentActionPath = new SweetPath<keyof GetReservationPaymentPathParameters>(
  '/reservations/{reservationId}/payment',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationPayment actions.
 */
export default function createGetReservationPaymentAction(axios: AxiosInstance) {
  return function getReservationPaymentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservationPaymentPathParameters;
    query?: GetReservationPaymentQueryParameters;
  }) {
    const path = getReservationPaymentActionPath.insert(parameters);

    return axios.get<GetReservationPaymentResponse, GetReservationPaymentResponse>(path, { params: query, headers });
  };
}
